/**
 * Composition method for endpoint footer
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { getLyraEndpoints } from '@/core/modules/lyra/services';

export function endpointFooterComposition () {
	const route = useRoute();
	const router = useRouter();

	// Computed Section Id
	const sectionId = computed((): string => route.params.sectionId as string);

	// Computed sections
	const sections = computed((): any[] => {
		const allSections = getLyraEndpoints('sections');
		return allSections.filter((_: any) => _.footer !== 'false');
	});

    function getDisplayMenuEndpoints (endpointId: string) {
        const sectionName = sections.value.find((_) => _.endpointId === endpointId);
        const endpointsTierName = sectionName.endpoints;
        const endpoints = getLyraEndpoints(endpointsTierName);
        const endpointsMenu = endpoints.filter((_: any) => _['menu-display'] === 'true');

        return endpointsMenu;
    }

	// Function to get subsections
	function getSubsections (endpointId: string) {
        const sectionName = sections.value.find((_) => _.endpointId === endpointId);
        const sectionTierName = sectionName.sections;
        const subSections = getLyraEndpoints(sectionTierName);

        return subSections;
    }

	// Function to navigate to endpoint
    function navigateToEndpoint (subsectionId: string, activeSection: string): void {
        const sectionName = sections.value.find((_) => _.endpointId === activeSection);
        const sectionsTierName = sectionName.sections;
        const endpointsTierName = sectionName.endpoints;
        const endpoints = getLyraEndpoints(endpointsTierName);
        const firstEndpoint = endpoints.find((_) => _[sectionsTierName] === subsectionId);
        router.push(`/covid-hub/endpoint/${activeSection}/${firstEndpoint.endpointId}`);
    }
	
    // Function to navigate to endpoint
    function navigateTo (endpointId: string, activeSection: string): void {
        router.push(`/covid-hub/endpoint/${activeSection}/${endpointId}`);
    }

	// Navigate to gallery
	function navigateGallery (): void {
        router.push(`/covid-hub/gallery/${sectionId.value}`);
    }

	return { 
        sections, getSubsections, navigateToEndpoint, navigateGallery,
        getDisplayMenuEndpoints, navigateTo
    }
}
